// extracted by mini-css-extract-plugin
module.exports = {"transactionPreview":"component_transactionPreview__153s5","table":"component_table__2QEhG"};